module.exports = "/assets/data/4a5a4922ef2dfcab8f3e729bcfbe30af-TN6.data.json";